import script from "./NavigationBranding.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationBranding.vue?vue&type=script&setup=true&lang=js"

import "./NavigationBranding.vue?vue&type=style&index=0&id=3ce936d4&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce936d4"]])

export default __exports__